import React, { useEffect } from 'react';
import './Vacancies.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import indexJobs from 'actions/job/index';
import indexDiscipline from 'actions/discipline/index';
import VacancyCard from 'components/Layout/components/VacancyCard/VacancyCard';

const colors = Array(20)
    .fill([
        { name: 'primary', hex: '#1e265c' },
        { name: 'purple', hex: '#6e38a6' },
        { name: 'yellow', hex: '#f4bb56' },
        { name: 'blue', hex: '#2db1d8' },
    ])
    .flat();

export default function Vacancies() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(indexDiscipline());
        dispatch(indexJobs());
    }, []);

    const vacancies = useSelector((state) =>
        state.job.entities.allIds.map((id) => state.job.entities.byId[id])
    );

    const vacanciesShortened = vacancies?.slice(0, 6);

    return (
        <div styleName="vacancies">
            {vacancies.length !== 0 ? (
                <>
                    {/* <CustomCarousel> */}
                    {vacanciesShortened.map((vacancy, i) => (
                        <VacancyCard
                            type="card"
                            backgroundColor="white"
                            vacancy={vacancy}
                            key={vacancy.id}
                            color={colors?.[i]}
                        />
                    ))}
                    {/* </CustomCarousel> */}
                </>
            ) : (
                <p>Er zijn op dit moment geen vacatures</p>
            )}
        </div>
    );
}
